var ASM = ASM || {}; // make sure ASM is available
var counter;
var carts;

ASM.emulate = {
    isCustomerSessionActive: function () {
        return $("#sessionTimer").length && $('#stopEmulate').length;
    },
    copyCustomerNameToId: function () {
        var $form = $("#_asmPersonifyForm");
        $form.find("input[name='customerId']").val($form.find("input[name='customerName']").val());
    },
    submitPeronifyFormOnActiveCustomerSession: function () {
        if (ASM.emulate.isCustomerSessionActive()) {
            $("#_asmPersonifyForm").submit();
        }
    }
};

function addASMHandlers() {

    revertAutocompleteNormalize();
    removeAsmAlert(3000);
    addCloseBtnHandler();
    addASMFormHandler();
    addHideBtnHandler();
    customerListModalHandler();


    if (ASM.emulate.isCustomerSessionActive()) {
          startTimer();
    }

    var $_resetButton = $("#resetButton");
    var $_inputCustomerName = $("input[name='customerName']");
    var $_inputDocumentName = $("input[name='documentDisplay']");

    if ($_resetButton.length) {
        $_resetButton.click(function () {
            resetSession();
        });
    }

    if ($('.ASM_alert_cred').length) {
        $("input[name='username']").addClass('ASM-input-error');
        $("input[name='password']").addClass('ASM-input-error');
    }


    ASM.emulate.nameInputSelector = "#asmLoginForm input[name='username']";
    ASM.emulate.$nameInput = $(ASM.emulate.nameInputSelector);
    ASM.emulate.passwordInputSelector = "#asmLoginForm input[name='password']";
    ASM.emulate.$passwordInput = $(ASM.emulate.passwordInputSelector);

    checkSignInButton();

    $(document).on("keypup change blur", ASM.emulate.nameInputSelector, function (event) {
        checkSignInButton();
    });

    $(document).on("keyup change blur", ASM.emulate.passwordInputSelector, function (event) {
        checkSignInButton();
    });

    if ($_inputCustomerName.length > 0) {
        $_inputCustomerName.autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: ACC.autocomplete.searchResultBaseUrl + "/assisted-service/autocomplete",
                    dataType: "json",
                    data: {
                        customerId: request.term
                    },
                    success: function (data) {
                        response(data);
                    }
                });
            },
            minLength: 3,
            appendTo: "#asmAutoComplete",
            select: function (event, ui) {
                if (ui.item.email === "") {
                    event.preventDefault();
                    return;
                }

                /* insert item.value in customerId hidden field */
                $("input[name='customerId']").val(ui.item.email);
                $_inputCustomerName.val(ui.item.email);
                return false;

            }
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            if (typeof item.email !== "string") {
                return $("<li></li>").data("item.autocomplete", item).append($('<span class=noresult>').text(ASM_MESSAGES.customerIdNotFound))
                    .appendTo(ul);
            }

            var liClass = item.active === "active" ? 'isActive' : 'inActive ui-state-disabled';

            return $("<li></li>").addClass(liClass).data("item.autocomplete", item).append(
                $('<span>').addClass('name').text(item.firstName + ' ' + item.name),
                $('<span>').addClass('email').text(item.email),
                $('<span>').addClass('b2bUnit').text(item.b2bUnit),
                $('<span>').addClass('active').text(item.active)).appendTo(ul);
        };
    }

    if ($_inputDocumentName.length > 0 && $_inputCustomerName.length > 0) {
        $_inputDocumentName.autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: ACC.autocomplete.searchResultBaseUrl + "/assisted-service/autocompleteDocuments",
                    dataType: "json",
                    data: {
                        documentId: request.term,
                        customerId: $("input[name='customerId']").val()
                    },
                    success: function (data) {
                        response(data);
                    }
                });
            },
            minLength: 3,
            appendTo: "#asmAutoCompleteDocument",
            select: function (event, ui) {
                event.preventDefault();
                $_inputDocumentName.val(ui.item.displayId);
                $("input[name='documentId']").val(ui.item.id);
                $("input[name='documentType']").val(ui.item.type);
                ASM.emulate.submitPeronifyFormOnActiveCustomerSession();
            }
        }).data("ui-autocomplete")._renderItem = function (ul, item) {
            return $("<li></li>").data("item.autocomplete", item).append(
                $('<span>').addClass('displayId').text(item.displayId),
                $('<span>').addClass('type').text(item.type)).appendTo(ul);
        };
    }

    if ($("#_asmBindForm").length) {
        var customerId = $_inputCustomerName.attr('readonly');

        if (customerId === "readonly") {
            $(".ASM_icon-chain").removeClass('invisible').addClass('ASM_chain-bind');
        }
    }
}

$(document).ready(function () {
    addASMHandlers();

    $(document).on("click", ".js-select-store-label", function () {
        $("#colorbox .js-pickup-component").addClass("show-store");
        colorboxResize();
    });

    $(document).on("click", ".js-asm-store-finder-details-back", function () {
        $("#colorbox .js-pickup-component").removeClass("show-store");
    });

    $(document).on("keypress blur", "#ASM-customerName", function (event) {
        ASM.emulate.copyCustomerNameToId();
    });

    $('.js-asm-button-not-allowed button').on("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
    });
});

function addASMFormHandler() {
    if ($) {
        var $_asmForm = $(".asmForm");
        if ($_asmForm.length) {
            $_asmForm.each(function () {
                $(this).submit(function () {
                    $.ajax({
                        type: "POST",
                        url: $(this).attr('action'),
                        data: $(this).serialize(),
                        success: function (data) {
                            $("#_asm").replaceWith(data);
                            addASMHandlers();
                        }
                    });
                    return false;
                });
            });
        }
    }
}

function addCloseBtnHandler() {
    $("#_asm .closeBtn").click(function () {
        $("#_asm").remove();
        var url = "/assisted-service/quit";
        $.post(url, function () {
            var oldurl = window.location.href;
            var newurl = oldurl.replace("&asm=true", "").replace("?asm=true&", "?").replace("?asm=true", "");
            window.location.replace(newurl);
        });
    });
}

function addHideBtnHandler() {
    $("#_asm .ASM_control_collapse").click(function () {
        $("#_asm").toggleClass("ASM-collapsed");
    });
}

function startTimer() {
    sessionSec = timer;
    clearInterval(counter);
    counter = setInterval(timerFunc, 1000);
}

function timerFunc() {
    if (sessionSec <= 0) {
        clearInterval(counter);
        stopASMpersonify();
        return;
    }
    sessionSec = sessionSec - 1;
    var min = Math.floor(sessionSec / 60);
    var sec = sessionSec % 60;
    if (min < 10) {
        min = "0" + min;
    }
    if (sec < 10) {
        sec = "0" + sec;
    }
    $("#sessionTimer .ASM_timer_count").html("(" + min + ":" + sec + ")");
}

function resetSession() {
    var request = $.ajax({
        url: "/assisted-service/resetSession",
        type: "POST"
    });
    request.done(function () {
        sessionSec = timer + 1;
    });
    request.fail(function (jqXHR, textStatus) {
        $('#errors').empty();
        $('#errors').append("Request failed: " + textStatus);
    });
}

function stopASMpersonify() {
    $.ajax({
        url: "/assisted-service/personify-stop",
        type: "POST",
        success: function (data) {
            $("#_asm").replaceWith(data);
            addASMHandlers();
        }
    });
}

function isStartEmulateButtonPresent() {
    return $(".ASM-btn-start-session").length === 1;
}

function enableAsmPanelButtons() {
    $('div[id="_asm"] button').not(".ASM-btn-start-session, .ASM-btn-login").removeAttr('disabled');
    if (isStartEmulateButtonPresent()) {
        if ($("#_asmPersonifyForm input[name='customerId']").val() !== "") {
            $("#_asmPersonifyForm input[name='customerId']").parent().addClass("checked");
        }
    }
}

function placeholderNotAvailable() {
    var i = document.createElement('input');
    return !('placeholder' in i);
}

function removeAsmHover() {
    $('#asmHover').remove();
}

function toggleActivationState(button, activate) {
    if (activate) {
        button.removeAttr('disabled');
    } else {
        button.attr('disabled', '');
    }
}

function checkSignInButton() {
    if(ASM.emulate.$nameInput.length == 0 || ASM.emulate.$passwordInput.length == 0) return;
    var isEnabled = ASM.emulate.$nameInput.val().length > 0 && ASM.emulate.$passwordInput.val().length > 0;
    toggleActivationState($("#asmLoginForm button[type='submit']"), isEnabled);
}

function checkStartSessionButton(el) {
    toggleStartSessionButton(el, false);
    var checkSum = $(el.parentNode).siblings('.checked').length;
    if (checkSum > 0) {
        toggleActivationState($("button.ASM-btn-start-session"), true);
    }
}

function toggleBind(activate) {
    if ($("#_asmBindForm").length) {
        var bindIcon = $(".ASM_icon-chain");
        var bindButton = $("#_asmBindForm button.ASM-btn-bind-cart[type='submit']");
        if (activate) {
            bindButton.removeClass('hidden');
            bindIcon.removeClass('invisible');
        } else {
            bindButton.addClass('hidden');
        }
    }
}

function toggleStartSessionButton(el, activate) {
    var checkedItem = $(el).parent();
    var button = $("button.ASM-btn-start-session");
    if (activate) {
        button.removeAttr('disabled');
        checkedItem.addClass("checked");
    } else {
        button.attr('disabled', '');
        checkedItem.removeClass("checked");
    }
}

function formValidate(el, min, number, max) {
    if (!$(el).hasClass('placeholder')) {
        if ($(el).hasClass("ASM-input-error")) {
            toggleStartSessionButton(el, false);
            return false;
        }
        if (number !== false) {
            if (isNaN(el.value)) {
                toggleStartSessionButton(el, false);
                return false;
            }
        }
        if (el.value.length >= (min)) {
            toggleStartSessionButton(el, true);

            if (max !== undefined && el.value.length > (max)) {
                toggleStartSessionButton(el, false);
            }
        } else if (el.value.length === 0) {
            checkStartSessionButton(el);
        } else {
            toggleStartSessionButton(el, false);
            return false;
        }
        return true;
    }
    return false;
}

function revertAutocompleteNormalize() {
    /* After http://bugs.jqueryui.com/ticket/9762 there was a change when for empty value label is placed instead.
     * But we want to send empty values for NO_FOUND case */
    $.ui.autocomplete.prototype._normalize = function (a) {
        if (a.length && a[0].label && a[0].value) {
            return a;
        }
        return $.map(a, function (b) {
            if (typeof b === "string") {
                return {label: b, value: b};
            }
            return $.extend({label: b.label || b.value, value: b.value || b.label}, b);
        });
    };
}

function isErrorDisplayed() {
    return $('.ASM_alert').length;
}

function colorboxResize() {
    $.colorbox.resize()
}

function getCurrentEmulatedCustomerId() {
    if ($("#_asmBindForm input[name='customerId']").length) {
        return $("#_asmBindForm input[name='customerId']").val();
    }
    return "anonymous";
}

function getCustomerListSearchUrl() {
    var targetUrl = $(".js-customer-list-sorting").data('sort-url');
    targetUrl += $(".ASM_customer-list-modal .sort-refine-bar .form-control").val();
    var query = $("#ASM_customer-list-queryInput").val();
    var uriEncodedquery = encodeURIComponent(query);
    targetUrl += '&query=' + uriEncodedquery;

    return targetUrl;
}

function customerListModalHandler() {
    $(document).on("click", ".ASM_customer-list-modal .pagination a", function (e) {
        e.preventDefault();

        populateCustomerListModal($(this).attr('href'), ".asm-account-section", replaceCustomerListTable);
    });

    $(document).on("click", "#ASM_customer-list-sortOptions .sortOption", function (e) {
        e.preventDefault();
        var selectedOption = $(this).data('value');
        var previouslySelectedOption = $(".ASM_customer-list-modal .sort-refine-bar .form-control").val();
        if (selectedOption !== previouslySelectedOption) {
            $(".ASM_customer-list-modal .sort-refine-bar .form-control").val(selectedOption);
            var targetUrl = getCustomerListSearchUrl();
            populateCustomerListModal(targetUrl, ".asm-account-section", replaceCustomerListTable);
        }
    });

    $(document).on("click", "#ASM_customer-list-searchButton", function (e) {
        e.preventDefault();
        var targetUrl = getCustomerListSearchUrl();
        populateCustomerListModal(targetUrl, ".asm-account-section", replaceCustomerListTable);
    });

    $(document).on("change", ".ASM_customer-list-modal .sort-refine-bar .form-control", function (e) {
        e.preventDefault();

        var targetUrl = getCustomerListSearchUrl();
        populateCustomerListModal(targetUrl, ".asm-account-section", replaceCustomerListTable);
    });

    $(document).on("change", ".js-customer-list-select", function (e) {
        e.preventDefault();


        var targetUrl = $(this).data('search-url');
        targetUrl += $(this).val();

        var request = populateCustomerListModal(targetUrl, ".asm-account-section", replaceCustomerListTable);
        request.done(function () {
            $.colorbox.resize();
        });
    });
}

function addCustomerListSelect(componentToUpdate, data) {

    var selector = $(data).find('.js-customer-list-select');

    $(componentToUpdate).html(data);
    searchUrl = $(data).find('.js-customer-list-select').data('search-url');

    if (selector[0].options.length > 0) {
        searchUrl += selector[0].options[0].value;
    }

    var request = populateCustomerListModal(searchUrl, componentToUpdate, appendCustomerListTable);
    request.done(function () {
        ACC.colorbox.open("", {
            href: ".js-customer-list-modal-content",
            inline: true,
            className: 'ASM_customer-list-modal',
            width: "100%",
            maxWidth: "1200px",
            close: '<span class="ASM_icon ASM_icon-close"></span>',
            transition: 'none',
            scrolling: false,
            opacity: 0.7,
            top: 10,
            onOpen: function () {
                $(window).on("resize", colorboxResize);
            },
            onClosed: function () {
                $(window).off("resize", colorboxResize);
            }
        });
    });
}

function appendCustomerListTable(componentToUpdate, data) {
    $(componentToUpdate).append(data);
}

function replaceCustomerListTable(componentToUpdate, data) {
    $(componentToUpdate).html(data);
}

function populateCustomerListModal(targetUrl, componentToUpdate, callFunction) {
    var method = "GET";
    return $.ajax({
        url: targetUrl,
        type: method,
        success: function (data) {
            callFunction(componentToUpdate, data);
        },
        error: function (xht, textStatus, ex) {
            console.error("Failed to get customer list. %s", ex);
            document.location.reload();
        }
    });
}

function getAifTablePageSize() {
    var pagesNumber = 5; // number
    if ($(window).width() < 668) {
        pagesNumber = 10;
    }
    return pagesNumber;
}

function copyToClipBoard(text) {
    var $_asmCopyHoldText = $("#asmCopyHoldtext");
    $_asmCopyHoldText.val(text).show().select();
    try {
        return document.execCommand("copy");
    } catch (ex) {
        console.warn("Copy to clipboard failed.", ex);
        return false;
    } finally {
        $_asmCopyHoldText.hide();
    }
}

function addRatesTableSorterParser() {
    $.tablesorter.addParser({
        // set a unique id
        id: 'rates',
        is: function () {
            // return false so this parser is not auto detected
            return false;
        },
        format: function (s, table, cell) {
            return Math.floor($(cell).attr('data-text') * 10);
        },
        type: 'numeric'
    });
}

function removeAsmAlert(delay) {
    setTimeout(function () {
        $(".ASM_alert").fadeOut("slow");
    }, delay);
}

function checkCartIdFieldAndToggleBind(cartIdField) {
    if ($("input[name='customerId']").val().length > 0) {
        if (!isNaN(cartIdField.value)) {
            $("#_asmBindForm button[type='submit']").removeClass('hidden');
            $(".ASM_icon-chain").removeClass('invisible');
            return;
        }
    }
    $("#_asmBindForm button[type='submit']").addClass('hidden');
    $(".ASM_icon-chain").addClass('invisible');
}

$("#_asmBindForm input[name='documentId']").keyup(function () {
    checkCartIdFieldAndToggleBind(this);
});

$("#_asmBindForm input[name='documentId']").bind('paste', function () {
    var inputField = this;
    setTimeout(function () {
        checkCartIdFieldAndToggleBind(inputField);
    }, 100);
});


